import { css } from '@linaria/core';
import { Root as ImageRoot } from '../Image/styles';
import { TeaserContainer } from '../Teaser/styles';
import { Root as TeaserImage } from '../Teaser/TeaserImage/styles';
import media, { sizes } from '../primitives/Media';
import { OnImageText } from '../Teaser/styles';
import { Additive as TeaserAdditive } from '../Teaser/TeaserImage/styles';
import { slidesPerViewStage } from './getResponsiveSwiperParams';
import { BottomArea } from '../Teaser/primitives';
import { SublineWrapper } from '../Teaser/TeaserText/styles';
import { Typo } from '../primitives/Typo';
function getProportionalSlideWidth(stageRatio, viewSize) {
    const ratio = stageRatio === '1x1' ? stageRatio : 'default';
    const slidesPerView = slidesPerViewStage[ratio][viewSize + 1];
    return 1 / slidesPerView;
}
function getProportionalSsrTranslation(stageRatio, viewSize) {
    const slideWith = getProportionalSlideWidth(stageRatio, viewSize);
    const sliderPart = (1 - slideWith) / 2;
    return `${sliderPart}`;
}
export const Root = {
    base: css `
		position: relative;
		z-index: 0;
		width: 100%;

		&:hover,
		&:focus,
		&:focus-within {
			z-index: 2;
		}

		a {
			text-decoration: none;
		}

		.swiper {
			overflow: visible;

			.swiper-wrapper {
				margin-bottom: 80px;

				${media('max', 'xs')} {
					transform: translateX(calc(100% * (-2)));
				}
			}

			&:after {
				content: '';

				position: absolute;
				bottom: 0;

				width: 100%;
				height: 100%;
				/* ToDo: replace by global color CSS variable when in design system available (hex & rgb) */
				box-shadow:
					0 10px 20px rgb(0, 0, 0, 0.19),
					0 6px 6px rgb(0, 0, 0, 0.23);
			}

			.swiper-slide {
				overflow: hidden;
				height: auto;
				${media('max', 'xs')} {
					width: 100%;
				}

				&:after {
					pointer-events: none;
					content: '';

					position: absolute;
					z-index: 1;
					-webkit-transform: translate3d(0, 0, 0);

					display: block;

					width: 100%;
					padding-top: 100%;

					opacity: 1;
				}
			}
			.swiper-slide.swiper-slide-active {
				${TeaserAdditive.base} > div,
 			.${OnImageText.base} {
					opacity: 1;
				}
				.${OnImageText.base} {
					transform: translate3d(0, 0, 0);
				}
				&:after {
					opacity: 0;
				}

				.${BottomArea.base} {
					display: flex;
					padding: 32px 16px 16px 16px;
					/* ToDo: replace by global color CSS variable when in design system available (hex & rgb) */
					background: linear-gradient(to top, rgba(0, 0, 0, 0.7) 0, rgba(255, 0, 0, 0) 100%);
				}

				.${TeaserImage.base} {
					&:after {
						/* ToDo: replace by global color CSS variable when in design system available (hex & rgb) */
						background: rgba(0, 0, 0, 0) linear-gradient(rgba(0, 0, 0, 0) 75%, rgb(0, 0, 0) 120%) repeat
							scroll 0 0;
					}
				}
			}

			.swiper-slide-prev,
			.swiper-slide-next {
				.${TeaserImage.base} {
					&:after {
						/* ToDo: replace by global color CSS variable when in design system available (hex & rgb) */
						background:
							linear-gradient(90deg, rgba(0, 0, 0, 0.5) 0, transparent 20%) repeat scroll 0 0,
							rgba(0, 0, 0, 0) linear-gradient(-90deg, rgba(0, 0, 0, 0.5) 0, transparent 20%) repeat
								scroll 0 0;
					}
				}
			}

			&.swiper-free-mode {
				.swiper-wrapper {
					transition-timing-function: ease-out !important;
				}
			}

			@media (hover: hover) and (pointer: fine) {
				&:hover {
					.swiper-button-prev,
					.swiper-button-next {
						opacity: 1;

						.${TeaserImage.base} {
							&:after {
								/* ToDo: replace by global color CSS variable when in design system available (hex & rgb) */
								background:
									linear-gradient(90deg, rgba(0, 0, 0, 0.5) 0, transparent 20%) repeat scroll 0 0,
									rgba(0, 0, 0, 0) linear-gradient(-90deg, rgba(0, 0, 0, 0.5) 0, transparent 20%)
										repeat scroll 0 0;
							}
						}
					}
				}
			}

			@media (pointer: coarse) {
				.swiper-button-prev,
				.swiper-button-next {
					display: none;
				}
			}
		}

		.swiper-pagination {
			z-index: 0;
			bottom: -35px !important;
			opacity: 1;
		}

		.swiper-pagination-bullet {
			width: 12px;
			height: 12px;
			opacity: 1;
			background-color: transparent;

			&:before {
				content: '';

				display: block;

				width: 6px;
				height: 6px;
				margin: 3px auto 0;
				border-radius: 50%;

				background-color: rgba(var(--text-color-body-01), 0.5);
			}
		}
		.swiper-pagination-bullet-active {
			background-color: transparent;
			&:before {
				width: 12px;
				height: 12px;
				margin-top: 0;
				background-color: rgb(var(--text-color-body-01), 0.8);
			}
		}
	`,
    /* Set styles for adult themes (light & dark) */
    adult: css `
		.swiper {
			.swiper-slide.swiper-slide-active {
				.${OnImageText.base} {
					.${Typo.base} {
						/* stylelint-disable-next-line -- ToDo: replace by global color CSS variable when in design system available (hex & rgb) */
						color: #fff;
					}
				}
				.${SublineWrapper.base} {
					> div:first-child {
						/* stylelint-disable-next-line -- ToDo: replace by global color CSS variable when in design system available (hex & rgb) */
						color: #fff;
					}
				}
			}
		}
	`,
    hoverEffect: {
        default: null,
        scale: css `
			.swiper {
				overflow: visible;

				.swiper-pagination {
					z-index: 0;
					bottom: -15px;
				}
				.swiper-scrollbar {
					bottom: -20px;
				}
			}

			.swiper-slide:first-child {
				@media (hover: hover) and (pointer: fine) {
					&:hover {
						.${TeaserContainer.base} {
							&:hover {
								left: 0;
							}
						}
					}
				}
			}
		`,
    },
    stageRatio: {
        default: css `
			.swiper {
				.swiper-wrapper {
					${media('min', 'xs')} {
						transform: translateX(calc(100% * ${getProportionalSsrTranslation('default', sizes.xs)}));
					}
					${media('min', 'l')} {
						transform: translateX(calc(100% * ${getProportionalSsrTranslation('default', sizes.l)}));
					}
					${media('min', 'xl')} {
						transform: translateX(calc(100% * ${getProportionalSsrTranslation('default', sizes.xl)}));
					}
					${media('min', 'xxl')} {
						transform: translateX(calc(100% * ${getProportionalSsrTranslation('default', sizes.xxl)}));
					}
				}
				.swiper-slide {
					&:after {
						/* ToDo: replace by global color CSS variable when in design system available (hex & rgb) */
						background: rgba(0, 0, 0, 0) linear-gradient(rgba(0, 0, 0, 0) 75%, rgb(0, 0, 0) 120%) repeat
							scroll 0 0;
						transition: 300ms all var(--global-ease-in-out);
					}
					${TeaserAdditive.base} > div,
  			.${OnImageText.base} {
						opacity: 0;
						transition: 200ms all var(--global-ease-out);
						transition-delay: 200ms;
					}
					.${OnImageText.base} {
						transform: translate3d(0, 30px, 0);
					}
					${media('min', 'xs')} {
						width: calc(100vw * ${getProportionalSlideWidth('default', sizes.xs)});
					}
					${media('min', 's')} {
						width: calc(100vw * ${getProportionalSlideWidth('default', sizes.s)});
					}
					${media('min', 'm')} {
						width: calc(100vw * ${getProportionalSlideWidth('default', sizes.m)});
					}
					${media('min', 'l')} {
						width: calc(100vw * ${getProportionalSlideWidth('default', sizes.l)});
					}
					${media('min', 'xl')} {
						width: calc(100vw * ${getProportionalSlideWidth('default', sizes.xl)});
					}
					${media('min', 'xxl')} {
						width: calc(100vw * ${getProportionalSlideWidth('default', sizes.xxl)});
					}
				}

				.${ImageRoot.base} {
					&:before {
						padding-top: calc(100% * 9 / 16);

						${media('max', 'xs')} {
							padding-top: calc((100% * 1) / 1);
						}

						${media('min', 'l')} {
							padding-top: calc((100% * 7) / 16);
						}
					}
				}
			}
		`,
        '1x1': css `
			.swiper {
				.swiper-wrapper {
					${media('min', 'xs')} {
						transform: translateX(calc(100% * ${getProportionalSsrTranslation('1x1', sizes.xs)}));
					}
					${media('min', 's')} {
						transform: translateX(calc(100% * ${getProportionalSsrTranslation('1x1', sizes.s)}));
					}
					${media('min', 'm')} {
						transform: translateX(calc(100% * ${getProportionalSsrTranslation('1x1', sizes.m)}));
					}
					${media('min', 'l')} {
						transform: translateX(calc(100% * ${getProportionalSsrTranslation('1x1', sizes.l)}));
					}
					${media('min', 'xl')} {
						transform: translateX(calc(100% * ${getProportionalSsrTranslation('1x1', sizes.xl)}));
					}
					${media('min', 'xxl')} {
						transform: translateX(calc(100% * ${getProportionalSsrTranslation('1x1', sizes.xxl)}));
					}
				}
				.swiper-slide {
					&:after {
						opacity: 0.5;
						/* ToDo: replace by global color CSS variable when in design system available (hex & rgb) */
						background: rgba(0, 0, 0, 0) linear-gradient(rgba(0, 0, 0, 0) 75%, rgb(0, 0, 0) 120%) repeat
							scroll 0 0;
						transition: 300ms all var(--global-ease-in-out);
					}
					${media('min', 'xs')} {
						width: calc(100vw * ${getProportionalSlideWidth('1x1', sizes.xs)});
					}
					${media('min', 's')} {
						width: calc(100vw * ${getProportionalSlideWidth('1x1', sizes.s)});
					}
					${media('min', 'm')} {
						width: calc(100vw * ${getProportionalSlideWidth('1x1', sizes.m)});
					}
					${media('min', 'l')} {
						width: calc(100vw * ${getProportionalSlideWidth('1x1', sizes.l)});
					}
					${media('min', 'xl')} {
						width: calc(100vw * ${getProportionalSlideWidth('1x1', sizes.xl)});
					}
					${media('min', 'xxl')} {
						width: calc(100vw * ${getProportionalSlideWidth('1x1', sizes.xxl)});
					}
				}
				.swiper-slide.swiper-slide-active ~ .swiper-slide {
					&:after {
						opacity: 0.5;
						/* ToDo: replace by global color CSS variable when in design system available (hex & rgb) */
						background: rgba(0, 0, 0, 0) linear-gradient(rgba(0, 0, 0, 0) 75%, rgb(0, 0, 0) 120%) repeat
							scroll 0 0;
					}
				}
				.swiper-slide.swiper-slide-active {
					&:after {
						opacity: 0;
						/* ToDo: replace by global color CSS variable when in design system available (hex & rgb) */
						background: rgba(0, 0, 0, 0) linear-gradient(rgba(0, 0, 0, 0) 75%, rgb(0, 0, 0) 120%) repeat
							scroll 0 0;
					}
				}
				.${ImageRoot.base} {
					&:before {
						padding-top: 100%;
					}
				}
			}
		`,
    },
};
export const TitlePlaceholder = {
    base: css `
		position: absolute;
		top: 0;

		width: 30%;
		height: 100%;
		padding: 1rem 0;
	`,
};
export const TitlePlaceholderWrapper = {
    base: css `
		position: relative;
		width: 100%;
	`,
};
export const HiddenTitle = {
    base: css `
		opacity: 0;
	`,
};
export const HeadlineAnimation = {
    base: css `
		animation: fadeIn 200ms var(--global-ease-out);

		@keyframes fadeIn {
			0% {
				opacity: 0;
			}
			100% {
				opacity: 1;
			}
		}
	`,
};
export const InitAnimation = {
    base: css `
		animation: fadeScaleIn 200ms var(--global-ease-out);

		@keyframes fadeScaleIn {
			0% {
				transform: scale(1.5);
				opacity: 0;
			}
			100% {
				transform: scale(1);
				opacity: 1;
			}
		}
	`,
};
